import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
import { defineAsyncComponent } from "vue";
import { useUserStore } from "@/stores/modules/user";
export const contractManagementRouter: RouteRecordRaw[] = [
    {
        path: "/warehouseContract",
        name: "WarehouseContract",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "合同管理"
        },
        redirect: "/warehouseContract/index",
        children: [
            {
                path: "index",
                name: "WarehouseContractIndex",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/contractManagement/index.vue");
                    }
                }),
                meta: {
                    title: "合同管理",
                    hidden: true,
                    activeMenu: "WarehouseContract",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseContractDetail",
                name: "WarehouseContractDetail",
                component: () => import("@/views/pages/warehouseSupervision/contractManagement/detail.vue"),
                meta: {
                    title: "合同详情",
                    activeMenu: "WarehouseContract",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "warehouseContractAdd",
                name: "WarehouseContractAdd",
                component: () => import("@/views/pages/warehouseSupervision/contractManagement/form.vue"),
                meta: {
                    title: "新增合同",
                    activeMenu: "WarehouseContract",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseContractEdit",
                name: "WarehouseContractEdit",
                component: () => import("@/views/pages/warehouseSupervision/contractManagement/form.vue"),
                meta: {
                    title: "修改合同",
                    activeMenu: "WarehouseContract",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
